import Breadcrumbs from './Breadcrumbs'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    indicatorsData: state.INDICATORS.indicatorsData
  }
}

export default withRouter(connect(mapStateToProps)(Breadcrumbs))



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/index.js